import { ExpandedState, SortingState, OnChangeFn } from '@tanstack/react-table'
import { create } from 'zustand'

interface ProductsTableState {
  page: number
  pageSize: number
  sorting: SortingState
  expanded: ExpandedState

  setPage: (page: number) => void
  setPageSize: (pageSize: number) => void
  setSorting: OnChangeFn<SortingState>
  setExpanded: OnChangeFn<ExpandedState>

  handlePageChange: (newPage: number) => void
  handlePageSizeChange: (newPageSize: number) => void
}

export const useProductsTableStore = create<ProductsTableState>((set) => ({
  page: 1,
  pageSize: 20,
  sorting: [],
  expanded: {},

  setPage: (page) => set({ page }),
  setPageSize: (pageSize) => set({ pageSize }),
  setSorting: (updaterOrValue) =>
    set((state) => ({
      sorting:
        typeof updaterOrValue === 'function'
          ? updaterOrValue(state.sorting)
          : updaterOrValue,
    })),
  setExpanded: (updaterOrValue) =>
    set((state) => ({
      expanded:
        typeof updaterOrValue === 'function'
          ? updaterOrValue(state.expanded)
          : updaterOrValue,
    })),

  handlePageChange: (newPage) => set({ page: newPage }),
  handlePageSizeChange: (newPageSize) =>
    set({ pageSize: newPageSize, page: 1 }),
}))
